import styled from "styled-components";
import { ReactComponent as SvgCircle } from "../../assets/svg/bg-circle-1.svg";
import { svgBgCompSharedStyles } from "../../config/theme/mixins";

export const SvgBgCircleBlue = styled(SvgCircle)`
  ${svgBgCompSharedStyles};
`;
